// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const ReviewsAnalyticsAPI = {
    GetAnalytics(fn, req) {
        return fn(`/reviews/v1/analytics?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetAnalyticsMulti(fn, req) {
        return fn(`/reviews/v1/analytics/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
